const initialState = [];

function userReducer(state = initialState, action) {
  switch (action.type) {
    case "user/update":
      return action.payload;
    default:
      return state;
  }
}

export default userReducer;
